'use strict';

var AppState = require('app_state');
var Consts = require('consts');
var i18n = require('utils/i18n');
var Lock = require('components/common/behaviors/lock');
var Misc = require('utils/misc');
var Devices = require('models/devices');
var popoverContent = require('components/devices/templates/common/info_popover');
var initializeAndShowPlugin = require('components/common/views/plugin_views');

var InfoView = Marionette.LayoutView.extend({
    templateEventLog: require('components/devices/templates/common/event_log_item'),
    template: require('components/common/templates/info'),
    controller: undefined,
    model: {},

    ui: {
        statusIcon: '.js-popover-anchor',
    },

    events: {
        'click button.js-modal_details': 'showSettingsDialog',
        'click button.js-modal_grouping': 'showGroupingDialog',
        'click button.js-modal_contract': 'showContractDialog',
        'click button.js-reinitialize': 'reInitialize',
        'click button.js-connection-infos': 'showConnectionInfoDialog',
    },

    regions: {
        plugin: '#js-plugin',
    },

    behaviors: {
        lock: {
            behaviorClass: Lock,
            buttons: ['button.js-modal_details', 'button.js-reinitialize', 'button.js-connection-infos'],

            getDeviceID: function (view) {
                return view.model.id;
            },
        },
    },

    initialize: function (options) {
        this.controller = options.controller;
        this.noDeviceError = options.noDeviceError;
        this.deviceCategory = options.deviceCategory;
        this.userIsExpert = AppState.user.attributes.is_expert;
        this.typeConst = Consts.Category[this.deviceCategory];
        this.eventLogReq = options.eventLog;
        this.simInfoReq = options.simInfo;
        this.smartTemp = options.model.get('smartTempInfo');
    },

    onShow: function () {
        var self = this;
        this.initPopover();

        $.when(this.eventLogReq, this.simInfoReq).done(function (eventLog, simInfo) {
            if (eventLog != undefined) {
                self.eventLog = eventLog.models.slice(0, 5);
            }
            if (simInfo != undefined) {
                self.simInfo = simInfo;
            }
            if (eventLog || simInfo) {
                self.render();
            }
        });
    },

    onRender: function () {
        this.initPopover();
        initializeAndShowPlugin(this, 'info', 'plugin', { model: this.model });
    },

    setPermission: function (permissions) {
        this.readOnly = permissions.get(Consts.Permissions.Info);
        this.isEventLog = permissions.get(Consts.Permissions.EventLog) !== undefined;
    },

    showSettingsDialog: function (e) {
        e.preventDefault();
        var self = this;
        this.controller.showSettingsDialog(this.model, function () {
            self.render();
        });
    },

    showContractDialog: function (e) {
        e.preventDefault();
        var self = this;
        this.controller.showContractDialog({
            model: this.model,
            update_cb: function () {
                self.render();
            },
        });
    },

    showGroupingDialog: function (e) {
        e.preventDefault();
        var self = this;
        this.controller.showGroupingDialog({
            readOnly: this.readOnly,
            models: [this.model],
            update_cb: function () {
                self.render();
            },
        });
    },

    reInitialize: function (e) {
        e.preventDefault();
        var self = this;
        this.controller.reInitializeDevice({
            id: this.model.id,
            schema_init: false,
            update_cb: function (updatedModel) {
                self.model.set(updatedModel);
                self.render();
            },
        });
    },

    serializeData: function () {
        var data = Marionette.ItemView.prototype.serializeData.apply(this, arguments);

        var categoryData = Consts.DeviceCategory[this.deviceCategory];
        var categoryKey = categoryData.categoryKey;
        var labels = this.model.getLabels().toJSON();

        data.readOnly = categoryData.noEdit || this.readOnly;
        data.noReinitialize = categoryData.noReinitialize || data.status == -4;
        data.language = i18n.language;
        data.noDeviceError = this.noDeviceError;
        data.publicLabels = _.sortBy(labels.tags, function (e) {
            return e.toLowerCase();
        });
        data.privateLabels = _.sortBy(labels.groups, function (e) {
            return e.toLowerCase();
        });
        data.hasLabels = data.publicLabels.length + data.privateLabels.length > 0;
        data.device_link = Misc.getDeviceURL(data.category, data.id);
        data.isEventLog = this.isEventLog;
        data.eventLog = this.getEventLog();
        data.categoryLink = categoryData.url;
        data.deviceCategory = this.deviceCategory;
        data.infoConfig = Consts.InfoConfig[categoryKey];
        data.dlc = this.getDownloadableContent();
        data.hasDlc = data.dlc.length > 0;
        data.simInfo = this.simInfo;
        data.showSimInfo = this.simInfo && this.simInfo.Imsi && this.simInfo.Imei;
        data.caption = {
            registered: Misc.getCaption('dates', 'registered', categoryKey),
            lastContact: Misc.getCaption('dates', 'last_seen', categoryKey),
        };

        data.deviceImg = '../img/devices/' + this.model.getImageName(false);
        data.deviceImg404 = this.getDeviceImage404();
        data.contractNr = this.model.get('contractNr');
        data.canEditContractNr = this.model.get('wired_to') == this.model.id;

        var trovisInfos = this.model.attributes.trovis_io_infos;
        if (!$.isEmptyObject(trovisInfos)) {
            data.trovisIO = { 11: '--', 12: '--', 13: '--' };
            var capabilities = this.model.attributes.capabilities;
            var circuitNames = {};
            if (this.model.attributes.circuit_names) {
                circuitNames = JSON.parse(this.model.attributes.circuit_names);
            }

            // gather display information for each configured trovis IO circuit
            _.each(data.trovisIO, function (_, circuitID) {
                if (capabilities['13' + circuitID] !== undefined) {
                    data.trovisIO[circuitID] = {
                        firmware: '--',
                        name: circuitNames['control-' + circuitID] || i18n.TR('Heizkreis') + ' ' + circuitID,
                    };
                    if (trovisInfos[circuitID]) {
                        data.trovisIO[circuitID]['firmware'] = trovisInfos[circuitID]['firmware'] / 100;
                    }
                }
            });
        }

        data.userIsExpert = this.userIsExpert;
        // HACK: filter generic modbus device fields -> hide if not available
        if (categoryKey == 'Modbus') {
            var updatedInfoConfigAttributes = {};
            _.each(data.infoConfig.attributes, function (v, k) {
                if (data[k] && data[k] != '') {
                    updatedInfoConfigAttributes[k] = v;
                }
            });

            data.infoConfig.attributes = updatedInfoConfigAttributes;
            data.noReinitialize = true;
        }

        if (this.model.isExternalDevice()) {
            // overwrite
            data.infoConfig.attributes = {
                firmware: i18n.TR('Version'),
                hardware: i18n.TR('Hersteller-ID'),
            };
            data.infoConfig.connection = {};
            data.has_manual = false;
            data.noReinitialize = true;
            data.isExternalDevice = true;
        }
        data.showStatus = true;

        if (this.smartTemp) {
            data.warnings = this.smartTemp.getWarnings();
        }
        return data;
    },

    getDownloadableContent: function () {
        var result = [];
        for (var key in Consts.ExternalContent) {
            var href = this.getManualLink(key, i18n.language);
            if (href) {
                result.push({
                    href: href,
                    text: Consts.ExternalContent[key],
                    download: false,
                });
            }
        }
        return result;
    },

    getManualLink: function (doc, lang) {
        // determine device type
        var type = this.model.get('type');
        type += Devices.IsEthernetController(this.model.attributes) ? '-e' : '';

        // SAMSON devices? -> link to SAMSON homepage
        if (type.startsWith('55') || type.startsWith('50')) {
            // only link to documentation
            if (doc != 'd') return '';

            // prepare link
            var samsonLinkLang = ['de', 'en', 'fr', 'es'].indexOf(lang) != -1 ? lang : 'en';
            var samsonLinkPrefix = 'https://www.samsongroup.com/' + samsonLinkLang;
            var docPrefix = '/search/?q=EB';

            var typeMapping = {
                '5573_1': '5573-1',
                5014: '5655',
                5024: '5656',
                5015: '5660',
            };

            return samsonLinkPrefix + docPrefix + (typeMapping[type] || type);
        }

        // special cases
        switch (type) {
            case 'EQJW126':
                if (doc != 'w') return '';
                if (lang === 'de') {
                    return 'https://www.sauter-controls.com/produkt/heizungsregler-mit-digitaler-bedienoberflaeche-equitherm/';
                }
                return 'https://www.sauter-controls.com/en/product/heating-controller-with-digital-user-interface-equitherm/';
            case 'EQJW146':
                if (doc != 'w') return '';
                if (lang === 'de') {
                    return 'https://www.sauter-controls.com/produkt/heizungs-und-fernwaermeregler-equitherm/';
                }
                return 'https://www.sauter-controls.com/en/product/heating-and-district-heating-controller-equitherm/';
            case 'EQJW246':
                if (doc != 'w') return '';
                if (lang === 'de') {
                    return 'https://www.sauter-controls.com/produkt/heizungs-und-fernwaermeregler-equitherm-2/';
                }
                return 'https://www.sauter-controls.com/en/product/heating-and-district-heating-controller-equitherm-2/';
            case 'PCR06':
                if (doc != 'w') return '';
                return 'https://www.pewo.com/produkte/';
        }

        return '';
    },

    getDeviceImage404: function () {
        var category = this.deviceCategory.toLowerCase();
        switch (category) {
            case 'meter':
                return 'meter_wmz_large.png';
            case 'sensor':
                if (this.model.get('type').startsWith('EXT_LORAWAN')) {
                    return 'lorawan.png';
                } else {
                    return 'unknown_large.png';
                }
            default:
                return 'unknown_large.png';
        }
    },

    getEventLog: function () {
        var self = this;
        var result = '';
        if (this.eventLog) {
            _.each(this.eventLog, function (eli) {
                var data = eli.toJSON();
                self.setEventData(data);
                result += self.templateEventLog(data);
            });
        }
        return result;
    },

    showConnectionInfoDialog: function (e) {
        e.preventDefault();
        // get simInfo from backend
        var infosReq = this.model.getSimInfo('long');
        this.controller.showConnectionInfoDialog(infosReq);
    },

    setEventData: function (item) {
        switch (item.item_type) {
            case 'device_status':
            case 'device_ok':
                item.errors = Misc.getErrorsFromStatus(item.ref_id, item.category, item.custom_data);
                break;
        }
    },

    initPopover: function () {
        var errorMessages = [];
        var errors = Misc.getErrorsFromStatus(
            this.model.attributes.status,
            this.model.get('category'),
            this.model.getStatusDataText()
        );

        _.each(errors, function (e) {
            errorMessages.push(e.text.length < 50 ? e.text : e.text.substring(0, 50) + '...)');
        });

        if (errorMessages.length > 0) {
            this.ui.statusIcon.popover({
                trigger: 'focus',
                content: popoverContent({ errorMessages: errorMessages }),
                placement: 'auto right',
                html: true,
            });
        }
    },
});

module.exports = InfoView;
